var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"show-more__container",style:(_vm.containerStyles),on:{"click":function($event){return _vm.$emit('click')}}},[_vm._v("\n  Alle "+_vm._s(_vm.totalElements)+" Bilder anzeigen\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }